var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style),attrs:{"id":"tab"},on:{"click":function($event){return _vm.click()}}},[_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }